// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3OQ7n","calendarButtons":"ClockData_calendarButtons__3Wy4U"};